import { useEffect, useState } from 'react';
import { getSkillDataAPI } from './utils';

export function useSkill({ skillID }) {
  const [skillData, setSkillData] = useState(null);
  const [skillCourses, setSkillCourses] = useState([]);
  const [skillCoursesLoaded, setSkillCoursesLoaded] = useState(false);

  useEffect(() => {
    getSkillDataAPI(skillID, getSkillCoursesCallback);
  }, []);

  const getSkillCoursesCallback = (data) => {
    setSkillData(data)
    setSkillCourses(data?.data?.courses ?? []);
    setSkillCoursesLoaded(true);
  };

  return {
    skillCourses,
    skillCoursesLoaded,
    skillData
  }
}
